import {
	ATTRIBUTION_PARAMS,
	EXCLUDED_FROM_COMPARISON,
} from "@shared/constants";

/**
 * Extracts attribution parameters from a URL (excluding click_id/pixel variations)
 * @param url - The URL to extract params from
 * @returns Map of attribution parameter key-value pairs
 */
export default function getAttributionParams(
	url: string | URL,
): Map<string, string> {
	const attributionMap = new Map<string, string>();

	try {
		const urlObj = typeof url === "string" ? new URL(url) : url;
		const params = urlObj.searchParams;

		for (const [key, value] of params.entries()) {
			const lowerKey = key.toLowerCase();
			if (
				ATTRIBUTION_PARAMS.has(lowerKey) &&
				!EXCLUDED_FROM_COMPARISON.has(lowerKey)
			) {
				attributionMap.set(lowerKey, value);
			}
		}
	} catch {
		// Invalid URL, return empty map
	}

	return attributionMap;
}
